import qs from 'qs'

import { CustomerSession, CustomerTypes } from 'modules/customer'
import { apiService } from 'shared/api'

export interface LoginUserResponse {
  data: {
    data: CustomerSession
  }
}

const api = apiService()

type RegistrationPayload = {
  firstName: string
  lastName: string
  phoneNumber?: string
  email: string
  password: string
  postalCode?: string
  regulationsAccepted: boolean
  smsConsentsGranted: boolean
  verificationSmsCode?: string
}

export type LoginUserPayload = {
  email: string
  password: string
}

export type EmailConfirmationPayload = {
  query: string
}

export type SupportSessionPayload = {
  // One-time handle token for triggering a support session.
  token: string
}

export type ResetPasswordPayload = {
  email: string
}

export type NewPasswordPayload = {
  password: string
  passwordConfirmation: string
  signature?: string
  expires?: string
  token?: string
  email?: string
}

export const resetPassword = (payload: ResetPasswordPayload) =>
  api.post('/forgot-password', payload)

export const setNewPassword = (payload: NewPasswordPayload) => {
  const { signature, expires, token, email, password, passwordConfirmation } = payload
  const query = qs.stringify({
    email,
    expires,
    token,
    signature
  })
  const body = {
    password,
    passwordConfirmation,
    email,
    token
  }

  return api.post(`/password/reset?${query}`, body)
}

interface RegisterUserResponse {
  data: {
    data: CustomerTypes
  }
}

export const registerUser = (payload: RegistrationPayload): Promise<RegisterUserResponse> =>
  api.post('/register', payload)

export const loginUser = (payload: LoginUserPayload): Promise<LoginUserResponse> =>
  api.post('/login', payload)

export const confirmEmail = (payload: EmailConfirmationPayload) =>
  api.get(`/email-confirmation?${payload.query}`)

export const updateEmailConfirmation = (payload: EmailConfirmationPayload) =>
  api.get(`/update-email-confirmation?${payload.query}`)

export const resendActivationLink = ({ email }: { email: string }) =>
  api.post('/resend-activation-email', { email })

export const resendEmailChangeLink = ({ email }: { email: string }) =>
  api.post('/resend-update-email-confirmation', { email })

export const createSupportSession = (payload: SupportSessionPayload): Promise<LoginUserResponse> =>
  api.post('/support-session', payload)

export const getVerificationSms = (phoneNumber: string) =>
  api.post(`/phone-number-verification-code/send`, { phoneNumber })
